import React, { useMemo } from 'react'
import { FinancialInfoData } from '../GeneralInformation/typesExtendedReport'
import { safeNum } from '../GeneralInformation/utils/extendedUtils'


export const useFinancialMappedData = (
    data: FinancialInfoData | null | undefined
) => {

    return useMemo(() => {
        if (!data) return null

        return {
            projectOverall: data.projectOverallStageCodeDisbursing,
            efas: data.distributionAccordingToLastestEfas,
            Last5Years: data.disbursementPorjectionLast5Years,
        }
    }, [data])
}
